var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGripVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 428 c-16 -16 -16 -80 0 -96 7 -7 28 -12 48 -12 20 0 41 5 48 12 16 16 16 80 0 96 -16 16 -80 16 -96 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 428 c-16 -16 -16 -80 0 -96 7 -7 28 -12 48 -12 45 0 60 15 60 60 0 45 -15 60 -60 60 -20 0 -41 -5 -48 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 288 c-16 -16 -16 -80 0 -96 16 -16 80 -16 96 0 16 16 16 80 0 96 -16 16 -80 16 -96 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 288 c-16 -16 -16 -80 0 -96 16 -16 80 -16 96 0 16 16 16 80 0 96 -16 16 -80 16 -96 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 148 c-16 -16 -16 -80 0 -96 16 -16 80 -16 96 0 16 16 16 80 0 96 -16 16 -80 16 -96 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 148 c-16 -16 -16 -80 0 -96 16 -16 80 -16 96 0 16 16 16 80 0 96 -16 16 -80 16 -96 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripVertical);
export default __webpack_public_path__ + "static/media/grip-vertical.bb785778210f62ecea960cf341e18367.svg";
export { ForwardRef as ReactComponent };